import React, { useCallback } from "react";
import MenuItemMaterial from "@material-ui/core/MenuItem";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
  root: {
    justifyContent: "space-between",
    paddingRight: "0.4rem",
  },
  content: {
    paddingRight: "0.8rem",
  },
}));

const MenuItem = ({
  children,
  rightIcon,
  itemRef,
  onClick,
  value,
  ...props
}) => {
  const classes = useStyles();
  const handleClick = useCallback(
    (e) => {
      return onClick?.(e, value);
    },
    [onClick, value]
  );

  return (
    <MenuItemMaterial
      {...props}
      className={classes.root}
      ref={itemRef}
      onClick={handleClick}
      value={value}
    >
      <Box className={classes.content}>{children}</Box>
      {rightIcon}
    </MenuItemMaterial>
  );
};

export default MenuItem;
